import { render, staticRenderFns } from "./AlertsCenter.vue?vue&type=template&id=d539a366"
import script from "./AlertsCenter.vue?vue&type=script&lang=js"
export * from "./AlertsCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports